import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/** Shared 6-digit OTP input. `action` renders on the right of the label
 *  (send / resend), `demoOtp` shows the code when on-screen mode is enabled. */
export const OtpField = ({
  label = "6-digit OTP", value, onChange, demoOtp, disabled, placeholder,
  action, testId, demoTestId, note,
}) => (
  <div>
    <div className="flex items-center justify-between">
      <Label>{label}</Label>
      {action}
    </div>
    <Input
      data-testid={testId}
      inputMode="numeric"
      maxLength={6}
      value={value}
      onChange={(e) => onChange(e.target.value.replace(/\D/g, ""))}
      disabled={disabled}
      placeholder={placeholder}
      required
    />
    {demoOtp && (
      <div
        className="mt-2 rounded-lg bg-secondary/10 border border-secondary/30 px-3 py-2 text-xs flex items-center gap-2"
        data-testid={demoTestId}
      >
        <span className="px-1.5 py-0.5 rounded bg-secondary text-secondary-foreground text-[10px] font-semibold">
          On screen
        </span>
        <span className="font-mono tracking-widest text-foreground">{demoOtp}</span>
        {note && <span className="text-muted-foreground ml-1">{note}</span>}
      </div>
    )}
  </div>
);

export default OtpField;
